import { Plugins } from '@leverege/plugin';
export { default as TermsAggResultProcessor } from "./TermsAggResultProcessor.js";
export { default as RangeAggResultProcessor } from "./RangeAggResultProcessor.js";
export { default as GeoDistanceAggResultProcessor } from "./GeoDistanceAggResultProcessor.js";
export { default as HistogramAggResultProcessor } from "./HistogramAggResultProcessor.js";
export { default as FilterAggResultProcessor } from "./FilterAggResultProcessor.js";
export { default as FiltersAggResultProcessor } from "./FiltersAggResultProcessor.js";
export const AggResultProcessorFactory = Plugins.createFactory('AggResultProcessor', {
  pluginKey: 'process'
});